import axios from "axios";

const IDENTITY_API_URL = process.env.REACT_APP_IDENTITYSERVICE_URL;
const CENTER_API_URL = process.env.REACT_APP_CENTERSERVICE_URL;
const SERVICE_API_URL = process.env.REACT_APP_SERVICE_URL;

export const SAVE_PROFILE = `${IDENTITY_API_URL}/api/v1/User/SaveProfile`;
export const REGISTER_PRODUCERCENTER = `${CENTER_API_URL}/api/v1/ProducerCenter/RegisterProducerCenter`;
export const GET_PRODUCERCENTER_BY_NAME = `${CENTER_API_URL}/api/v1/ProducerCenter/GetProducerCenterByName`;
export const GET_ALL_PRODUCER_CENTER_EMPLOYER = `${CENTER_API_URL}/api/v1/ProducerCenterEmployer/GetAllProducerCenterEmployer`;
export const GET_PRODUCER_CENTER_BY_ID = `${CENTER_API_URL}/api/v1/ProducerCenter/GetProducerCenterById`;
export const UPDATE_PRODUCER_CENTER = `${CENTER_API_URL}/api/v1/ProducerCenter/UpdateProducerCenter`;
export const DELETE_PRODUCER_CENTER_ICON = `${CENTER_API_URL}/api/v1/ProducerCenter/DeleteProducerCenterIcon`;
export const INVITE_USER_TO_PRODUCER_CENTER = `${CENTER_API_URL}/api/v1/ProducerCenterEmployer/InviteUserToProducerCenter`;
export const INVITE_USER_PRODUCER_CENTER = `${CENTER_API_URL}/api/v1/ProducerCenter/GetUserProducerCenter`;
export const GETCENTERWALLET = `${SERVICE_API_URL}/api/v1/Payment/GetProducerCenterWallet`;
export const DELETE_EMPLOYER_IN_PRODUCER_CENTER = `${CENTER_API_URL}/api/v1/ProducerCenterEmployer/DeleteEmployerInProducerCenter`;
export const GET_ALL_PRODUCER_CENTER_CONTACT = `${CENTER_API_URL}/api/v1/ProducerCenterContact/GetAllProducerCenterContact`;
export const UPDATE_PRODUCER_CENTER_CONTACT = `${CENTER_API_URL}/api/v1/ProducerCenterContact/UpdateProducerCenterContact`;
export const ADD_PRODUCER_CENTER_CONTACT = `${CENTER_API_URL}/api/v1/ProducerCenterContact/AddContactToProducerCenter`;
export const DELETE_CONTACT_IN_PRODUCER_CENTER = `${CENTER_API_URL}/api/v1/ProducerCenterContact/DeleteContactInProducerCenter`;

export function SaveProfile(nationalCode: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("NationalCode", nationalCode);
  return axios.post(SAVE_PROFILE, bodyFormData).catch((error) => {
    return error;
  });
}

export function RegisterProducerCenter(name: string, icon, ReferrerCode?: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("Name", name);
  bodyFormData.append("Icon", icon);
  if (ReferrerCode) {
    bodyFormData.append("ReferrerCode", ReferrerCode);
  }
  return axios.post(REGISTER_PRODUCERCENTER, bodyFormData).catch((error) => {
    return error;
  });
}

export function GetProducerCenterByName(name: string) {
  let data = axios
    .get(`${GET_PRODUCERCENTER_BY_NAME}?Name=${name}`)
    .catch((error) => {
      return error;
    });
  return data;
}

export function GetAllProducerCenterEmployer(
  ProducerCenterId,
  Page: number,
  PageSize: number,
  PhoneNumber: string
) {
  let url = `${GET_ALL_PRODUCER_CENTER_EMPLOYER}?ProducerCenterId=${ProducerCenterId}&Page=${Page}&PageSize=${PageSize}`;
  if (PhoneNumber != "") url = url + `&PhoneNumber=${PhoneNumber}`;
  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}
export function GetProducerCenterById(id) {
  var url = `${GET_PRODUCER_CENTER_BY_ID}/${id}`;
  return axios.get(url).catch((error) => {
    return error;
  });
}
export function UpdateProducerCenter(ProducerCenterId, Name: string, Icon) {
  var bodyFormData = new FormData();
  bodyFormData.append("ProducerCenterId", ProducerCenterId);
  bodyFormData.append("Name", Name);
  bodyFormData.append("Icon", Icon);

  let data = axios.post(UPDATE_PRODUCER_CENTER, bodyFormData).catch((error) => {
    return error;
  });
  return data;
}
export function DeleteProducerCenterIcon(ProducerCenterId) {
  var bodyFormData = new FormData();
  bodyFormData.append("ProducerCenterId", ProducerCenterId);

  let data = axios
    .post(DELETE_PRODUCER_CENTER_ICON, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}
export function InviteUserToProducerCenter(
  ProducerCenterId: string,
  PhoneNumber: string,
  CountryCode: string
) {
  var bodyFormData = new FormData();
  bodyFormData.append("ProducerCenterId", ProducerCenterId);
  bodyFormData.append("PhoneNumber", PhoneNumber);
  bodyFormData.append("CountryCode", CountryCode);

  let data = axios
    .post(INVITE_USER_TO_PRODUCER_CENTER, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}
export function GetUserProducerCenterRequest() {
  return axios.get(INVITE_USER_PRODUCER_CENTER).catch((error) => {
    return error;
  });
}
export function GetProducerCenterWalletPriceRequest(producerCenterId: string) {
  return axios
    .get(`${GETCENTERWALLET}?ProducerCenterId=${producerCenterId}`, {})
    .catch((error) => {
      return error;
    });
}
export function DeleteEmployerInProducerCenter(
  ProducerCenterEmployerId: number
) {
  let data = axios
    .delete(`${DELETE_EMPLOYER_IN_PRODUCER_CENTER}/${ProducerCenterEmployerId}`)
    .catch((error) => {
      return error;
    });
  return data;
}
export function GetAllProducerCenterContact(
  ProducerCenterId,
  Page: number,
  PageSize: number,
  Title: string
) {
  let url = `${GET_ALL_PRODUCER_CENTER_CONTACT}?ProducerCenterId=${ProducerCenterId}&Page=${Page}&PageSize=${PageSize}`;
  if (Title != "") url = url + `&Title=${Title}`;
  let data = axios.post(url).catch((error) => {
    return error;
  });
  return data;
}
export function UpdateProducerCenterContactReq(
  ProducerCenterContactId: number | null,
  Title: string | null,
  StaticPhoneNumber_PhoneStatic: string | null,
  StaticPhoneNumber_CountryId: number | null,
  StaticPhoneNumber_CountryCode: string | null,
  MobileNumber_MobileWithOutCountryCode: string | null,
  MobileNumber_CountryId: number | null,
  MobileNumber_CountryCode: string | null,
  Fax_Value: string | null,
  Address_CountryId: number | null,
  Address_CityId: number | null,
  Address_StateId: number | null,
  Address_Detail: string | null,
  Address_PostalCode: string | null,
  CoordinatesGPS_Latitude: string | null,
  CoordinatesGPS_Longitude: string | null,
  WebSites_Value: string | null,
  Emails_Value: string | null
) {
  const bodyFormData = new FormData();

  bodyFormData.append(
    "ProducerCenterContactId",
    ProducerCenterContactId !== null ? ProducerCenterContactId.toString() : ""
  );
  bodyFormData.append("Title", Title !== null ? Title : "");
  bodyFormData.append(
    "StaticPhoneNumber_PhoneStatic",
    StaticPhoneNumber_PhoneStatic !== null ? StaticPhoneNumber_PhoneStatic : ""
  );
  bodyFormData.append(
    "StaticPhoneNumber_CountryId",
    StaticPhoneNumber_CountryId !== null
      ? StaticPhoneNumber_CountryId.toString()
      : ""
  );
  bodyFormData.append(
    "StaticPhoneNumber_CountryCode",
    StaticPhoneNumber_CountryCode !== null ? StaticPhoneNumber_CountryCode : ""
  );
  bodyFormData.append(
    "MobileNumber_MobileWithOutCountryCode",
    MobileNumber_MobileWithOutCountryCode !== null
      ? MobileNumber_MobileWithOutCountryCode
      : ""
  );
  bodyFormData.append(
    "MobileNumber_CountryId",
    MobileNumber_CountryId !== null ? MobileNumber_CountryId.toString() : ""
  );
  bodyFormData.append(
    "MobileNumber_CountryCode",
    MobileNumber_CountryCode !== null ? MobileNumber_CountryCode : ""
  );
  bodyFormData.append("Fax_Value", Fax_Value !== null ? Fax_Value : "");
  bodyFormData.append(
    "Address_CountryId",
    Address_CountryId !== null ? Address_CountryId.toString() : ""
  );
  bodyFormData.append(
    "Address_CityId",
    Address_CityId !== null ? Address_CityId.toString() : ""
  );
  bodyFormData.append(
    "Address_StateId",
    Address_StateId !== null ? Address_StateId.toString() : ""
  );
  bodyFormData.append(
    "Address_Detail",
    Address_Detail !== null ? Address_Detail : ""
  );
  bodyFormData.append(
    "Address_PostalCode",
    Address_PostalCode !== null ? Address_PostalCode : ""
  );
  bodyFormData.append(
    "CoordinatesGPS_Latitude",
    CoordinatesGPS_Latitude !== null ? CoordinatesGPS_Latitude : ""
  );
  bodyFormData.append(
    "CoordinatesGPS_Longitude",
    CoordinatesGPS_Longitude !== null ? CoordinatesGPS_Longitude : ""
  );
  bodyFormData.append(
    "WebSites_Value",
    WebSites_Value !== null ? WebSites_Value : ""
  );
  bodyFormData.append(
    "Emails_Value",
    Emails_Value !== null ? Emails_Value : ""
  );

  let data = axios
    .post(UPDATE_PRODUCER_CENTER_CONTACT, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function AddContactToProducerCenter(
  ProducerCenterId: number | null,
  Titles: string | null,
  StaticPhoneNumber_PhoneStatic: string | null,
  StaticPhoneNumber_CountryId: number | null,
  StaticPhoneNumber_CountryCode: string | null,
  MobileNumber_MobileWithOutCountryCode: string | null,
  MobileNumber_CountryId: number | null,
  MobileNumber_CountryCode: string | null,
  Fax_Value: string | null,
  Address_CountryId: number | null,
  Address_CityId: number | null,
  Address_StateId: number | null,
  Address_Detail: string | null,
  Address_PostalCode: string | null,
  CoordinatesGPS_Latitude: string | null,
  CoordinatesGPS_Longitude: string | null,
  WebSites_Value: string | null,
  Emails_Value: string | null
) {
  const bodyFormData = new FormData();
  bodyFormData.append(
    "ProducerCenterId",
    ProducerCenterId !== null ? ProducerCenterId.toString() : ""
  );
  bodyFormData.append("Titles", Titles !== null ? Titles : "");
  bodyFormData.append(
    "StaticPhoneNumber_PhoneStatic",
    StaticPhoneNumber_PhoneStatic !== null ? StaticPhoneNumber_PhoneStatic : ""
  );
  bodyFormData.append(
    "StaticPhoneNumber_CountryId",
    StaticPhoneNumber_CountryId !== null
      ? StaticPhoneNumber_CountryId.toString()
      : ""
  );
  bodyFormData.append(
    "StaticPhoneNumber_CountryCode",
    StaticPhoneNumber_CountryCode !== null ? StaticPhoneNumber_CountryCode : ""
  );
  bodyFormData.append(
    "MobileNumber_MobileWithOutCountryCode",
    MobileNumber_MobileWithOutCountryCode !== null
      ? MobileNumber_MobileWithOutCountryCode
      : ""
  );
  bodyFormData.append(
    "MobileNumber_CountryId",
    MobileNumber_CountryId !== null ? MobileNumber_CountryId.toString() : ""
  );
  bodyFormData.append(
    "MobileNumber_CountryCode",
    MobileNumber_CountryCode !== null ? MobileNumber_CountryCode : ""
  );
  bodyFormData.append("Fax_Value", Fax_Value !== null ? Fax_Value : "");
  bodyFormData.append(
    "Address_CountryId",
    Address_CountryId !== null ? Address_CountryId.toString() : ""
  );
  bodyFormData.append(
    "Address_CityId",
    Address_CityId !== null ? Address_CityId.toString() : ""
  );
  bodyFormData.append(
    "Address_StateId",
    Address_StateId !== null ? Address_StateId.toString() : ""
  );
  bodyFormData.append(
    "Address_Detail",
    Address_Detail !== null ? Address_Detail : ""
  );
  bodyFormData.append(
    "Address_PostalCode",
    Address_PostalCode !== null ? Address_PostalCode : ""
  );
  bodyFormData.append(
    "CoordinatesGPS_Latitude",
    CoordinatesGPS_Latitude !== null ? CoordinatesGPS_Latitude : ""
  );
  bodyFormData.append(
    "CoordinatesGPS_Longitude",
    CoordinatesGPS_Longitude !== null ? CoordinatesGPS_Longitude : ""
  );
  bodyFormData.append(
    "WebSites_Value",
    WebSites_Value !== null ? WebSites_Value : ""
  );
  bodyFormData.append(
    "Emails_Value",
    Emails_Value !== null ? Emails_Value : ""
  );
  let data = axios
    .post(ADD_PRODUCER_CENTER_CONTACT, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function DeleteContactInProducerCenter(ProducerCenterContactId) {
  var bodyFormData = new FormData();
  bodyFormData.append("ProducerCenterContactId", ProducerCenterContactId);

  let data = axios
    .delete(DELETE_CONTACT_IN_PRODUCER_CENTER, {
      data: bodyFormData,
    })
    .catch((error) => {
      return error;
    });
  return data;
}
